<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h1 class="book-title"><a id="page_v"></a><span class="smallcaps">THE</span> CURSED</h1>
<p class="sub-title">A VAMPIRE HUNTRESS LEGEND</p>
<p class="author">L. A. BANKS</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/pub.jpg"/> ST. MARTIN’S GRIFFIN <img alt="Image" src="images/pub1.jpg"/> NEW YORK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5011aaca